<template>
  <div class="m-portlet m-portlet--mobile">
    <SearchTitle label='结业管理' url='/cycle/graduate/list'></SearchTitle>
    <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
      <!--begin: Search Form -->
      <div class="m-form m-form--label-align-right">
        <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
        <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
        <ZPGLSearchDictItemSelect v-model='condition.specialty' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
        <div style="float: left;margin-top: 10px;">
          <div class="m-form__group m-form__group--inline">
            <div class="m-form__label">
              <label style="width: 100px;text-align:right;">状态：</label>
            </div>
            <div class="m-form__control">
              <el-select v-model="condition.stustatus" filterable placeholder="全部">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="d-md-none m--margin-bottom-10"></div>
        </div>
        <div style="float: left;margin-top: 10px;">
          <div class="m-form__group m-form__group--inline">
            <div class="m-form__label">
              <label style="width: 100px;text-align:right;">结业时间：</label>
            </div>
            <div class="m-form__control">
              <el-date-picker v-model="condition.graduationdate" type="month" placeholder="结业时间" value-format="yyyy-MM">
              </el-date-picker>
            </div>
          </div>
          <div class="d-md-none m--margin-bottom-10"></div>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
        <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton>
      </div>
      <!--end: Search Form -->
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Datatable -->
        <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" size="medium">
          <el-table-column prop="StuName" label="姓名">
          </el-table-column>
          <el-table-column prop="StuNo" label="工号">
          </el-table-column>
          <el-table-column prop="SpecName" label="专业">
          </el-table-column>
          <el-table-column prop="GraduationDate" label="应结业时间">
          </el-table-column>
          <el-table-column prop="LeaveDayCount" label="请假天数">
          </el-table-column>
          <el-table-column prop="CPStatusName" label="轮转信息">
          </el-table-column>
          <el-table-column label="考评信息">
            <template slot-scope="scope">
              <span>{{scope.row.CPICount}}次,{{scope.row.AvgScore}}分</span>
            </template>
          </el-table-column>
          <el-table-column label="培训状态">
            <template slot-scope="scope">
              <div v-if="scope.row.StuEditStatus == 1 || scope.row.StuEditStatus == 5">
                <span>{{scope.row.StuEditStatusName}}</span>
              </div>
              <div v-if="scope.row.StuEditStatus == 2">
                <span style="color: green;">{{scope.row.StuEditStatusName}}</span>
              </div>
              <div v-if="scope.row.StuEditStatus == 3">
                <span style="color: red;">{{scope.row.StuEditStatusName}}</span>
              </div>
              <div v-if="scope.row.StuEditStatus == 4">
                <span style="color: #D79100;">{{scope.row.StuEditStatusName}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <el-button @click="Complete(scope.row)" type="text" size="medium" v-if="scope.row.StuEditStatus < 5">结业</el-button>
              <el-button @click="PDF(scope.row)" type="text" size="medium">导出PDF</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--end: Datatable -->
        <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
            :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="condition.recordCount">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GraduateList',
  data () {
    return {
      condition: {
        truename: '',
        cardno: '',
        specialty: '',
        stustatus: '',
        graduationdate: '',
        pageSize: 10,
        currentPage: 1,
        recordCount: 0,
        firstSearch: true
      },
      tableData: null,
      statusOptions: [{
        value: '1',
        label: '未入科'
      }, {
        value: '2',
        label: '在培'
      }, {
        value: '3',
        label: '缺勤'
      }, {
        value: '4',
        label: '延期'
      }, {
        value: '5',
        label: '已结业'
      }],
      searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/GraduateList',
      loading: true
    }
  },
  methods: {
    // 调整每页显示数
    handleCurrentChange: function (val) {
      this.condition.firstSearch = false
      this.condition.currentPage = val
      this.$refs.btnSearch.Search()
    },
    // 分页操作
    handleSizeChange: function (val) {
      this.condition.firstSearch = false
      this.condition.pageSize = val
      this.condition.currentPage = 1
      this.$refs.btnSearch.Search()
    },
    Complete: function (row) {
      this.$router.push({name: 'Graduate', params: {id: row.CPStuID}})
    },
    PDF: function (row) {
      var args = {
        token: this.condition.token,
        id: row.CPStuID
      }
      this.fullscreenLoading = true
      this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/GraduatePDF', args)
        .then(res => {
          if (res.data.Code === 0) {
            var filename = res.data.Data
            var url = this.$utils.Url.zpgl + '/pdf/' + filename
            window.open(url)
          }
          this.fullscreenLoading = false
        })
        .catch(err => {
          console.log(err)
          this.$message({
            message: '导出失败',
            type: 'error'
          })
          this.fullscreenLoading = false
        })
    }
  },
  mounted: function () {
    this.condition.token = sessionStorage.getItem('token')
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    this.condition.graduationdate = year + '-' + month
    this.$refs.btnSearch.Search()
  }
}
</script>

<style scoped="scoped">
  /deep/.el-input {
    width: 220px;
  }
</style>
